<template>
  <div>
    <a-row type="flex" justify="center">
      <a-col flex="1 1 200px" style="text-align: center; padding-top: 40px;">
        <img src="@/assets/img/company/itbstikomresmi.png" alt="asdsad" class="responsive" height="200"/>
        
      </a-col>
      <a-col flex="3 3 200px">
        <h3 >{{ $t("ujian.home.welcome") }}</h3>
        <h2>{{ this.$store.state.participant.biodata.name }}</h2>
        <!-- <p class="my-2">by PUSKOM ITB STIKOM Bali</p> -->
        
        Institut Teknologi dan Bisnis (ITB) STIKOM Bali merupalan Kampus Teknologi dan Bisnis terdepan di Bali dan Nusa Tenggara, 
        unggulan dan berkualitas Internasional di bidang ilmu pengetahuan, teknologi dan seni. Penerimaan mahasiswa baru ITB STIKOM  
        dilakukan dengan seleksi ujian secara online. 
        <a-divider />
        Silahkan klik tombol Selanjutnya untuk masuk ke Biodata Anda
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
   data(){
    return{
      
    }
  },
}
</script>


  